import React from 'react'
import ClockSVG from "../../../assets/icons/cook-time-clock.svg"
export const ClockIcon: React.FC = () => {
  return (
    <img src={ClockSVG} alt="" className="w-[22px] h-[22px]" />
  )
}
